export default __webpack_public_path__ + "static/media/tensor.4f2c31b9.png";